import omit from 'lodash/omit';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';

import { merge } from '../../../../utils/state';
import ReduxRestEntity from '../../../../utils/reduxRestEntity';
import { TYPES } from './actions';
import entity from './entity';

const coreReducer = entity.getReducer();

const INITIAL_STATE = {
  ...ReduxRestEntity.initialState,
  isLoading: false,
  isUpdating: false,
  pagination: {
    pageSize: 15,
    pageNumber: 1,
    hasMore: false,
    totalElements: 0,
  },
  isSponsorshipInfoLoading: false,
  sponsorshipInfo: null,
};

const reducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case TYPES.GET_HUBS_REQUEST:
      if (get(action, 'payload.page') === 1) {
        return merge(state, {
          data: {},
          error: null,
          isLoading: true,
          isUpdating: false,
          pagination: {
            pageSize: 15,
            pageNumber: 1,
            hasMore: false,
            totalElements: 0,
          },
        });
      }
      return merge(state, {
        isLoading: true,
      });
    case TYPES.GET_HUBS_SUCCESS:
      return merge(state, {
        isLoading: false,
        data: merge(state.data, action.payload.content),
        pagination: {
          ...state.pagination,
          pageNumber: action.payload.number + 1,
          hasMore: !action.payload.last,
          totalElements: action.payload.totalElements,
        },
      });
    case TYPES.GET_HUBS_FAILURE:
      return merge(state, {
        isLoading: false,
        error: isEmpty(action.payload) ? true : action.payload,
        pagination: {
          ...state.pagination,
          totalElements: 0,
        },
      });
    case TYPES.CREATE_HUB_REQUEST:
      return merge(state, {
        isLoading: true,
        newHubId: null,
        error: null,
      });
    case TYPES.CREATE_HUB_SUCCESS:
      return merge(state, {
        isLoading: false,
        newHubId: action.payload.id,
        error: null,
        data: { ...omit(action.payload, ['id']), ...state.data },
      });
    case TYPES.CREATE_HUB_FAILURE:
      return merge(state, {
        isLoading: false,
        newHubId: null,
        error: action.payload,
      });
    case TYPES.UPDATE_REQUEST:
      return merge(state, {
        isUpdating: true,
      });
    case TYPES.UPDATE_REQUEST_SUCCESS:
      return merge(state, {
        isUpdating: false,
        data: merge(state.data, action.payload),
      });
    case TYPES.UPDATE_REQUEST_ERROR:
      return merge(state, {
        isUpdating: false,
        error: action.payload,
      });
    case TYPES.CLEAR_NEW_HUB_ID:
      return merge(state, {
        newHubId: null,
      });
    case TYPES.RESET_NEW_HUB_ERROR:
      return merge(state, {
        error: null,
      });
    case TYPES.INCREMENT_TOTAL_HUBS:
      return merge(state, {
        pagination: {
          ...state.pagination,
          totalElements: state.pagination.totalElements + 1,
        },
      });
    case TYPES.GET_SPONSORSHIP_REQUEST:
      return merge(state, {
        isSponsorshipInfoLoading: true,
        sponsorshipInfo: null,
      });
    case TYPES.GET_SPONSORSHIP_SUCCESS:
      return merge(state, {
        isSponsorshipInfoLoading: false,
        sponsorshipInfo: action.payload,
      });
    case TYPES.GET_SPONSORSHIP_FAILURE:
      return merge(state, {
        isSponsorshipInfoLoading: false,
        sponsorshipInfo: null,
        error: action.payload,
      });
    case TYPES.CLEAR_STATE:
      return INITIAL_STATE;
    default:
      return coreReducer(state, action);
  }
};

export default reducer;
